var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.71 23.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.18,16.21c.12,0,.23-.05.32-.13l2.06-2.06c.17-.18.17-.46,0-.64-.18-.18-.46-.17-.64,0l-2.06,2.06c-.17.18-.17.46,0,.64.09.08.2.13.32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.45,7.28c-1.23-1.95-2.58-4.09-4.23-6.73-.23-.36-.56-.55-1-.55-5.06,0-10.37,0-15.77,0-.42,0-.75.18-.98.54l-1.97,3.15c-.76,1.21-1.54,2.47-2.31,3.7-.15.23-.22.54-.2.82.06.91.45,1.77,1.1,2.43.64.65,1.5,1.06,2.42,1.14.12.01.23.02.35.02,1.27,0,2.45-.64,3.15-1.65.67.97,1.71,1.58,2.86,1.63,1.1.04,2.03-.23,2.74-.82.27-.22.51-.49.72-.81.74,1.08,1.89,1.56,2.84,1.64.81.06,1.58-.1,2.27-.51.5-.3.91-.67,1.23-1.12.71,1.02,1.87,1.65,3.17,1.65,1.93,0,3.54-1.41,3.83-3.34.07-.43-.01-.81-.24-1.17Zm-16.51,3.08c-.92-.04-1.97-.74-2.23-2.21l-.59-3.33-.89,3.72c-.29,1.16-1.4,1.95-2.59,1.84-1.22-.12-2.17-1.07-2.26-2.25.7-1.13,1.42-2.28,2.12-3.39l2.08-3.34c5.31,0,10.52,0,15.51,0,1.62,2.6,2.95,4.71,4.17,6.63.03.05.05.09.03.21-.18,1.24-1.21,2.14-2.44,2.14-1.23,0-2.26-.9-2.44-2.13-.01-.1-.05-.18-.08-.25l-.93-2.34-.41,2.49c-.15.89-.54,1.49-1.24,1.91-.44.26-.92.36-1.44.32-.87-.07-1.98-.68-2.25-2.17l-.58-3.22-.79,3.17c-.19.77-.51,1.34-.95,1.7-.44.36-1.05.54-1.79.5ZM5.46,1.4s0,0,0,0v-.4h0v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.34,12.86c-.39,0-.7.31-.7.7v8.2h-2.67v-5.09c0-2.1-1.71-3.81-3.81-3.81s-3.81,1.71-3.81,3.81v5.09H4.08v-8.2c0-.39-.32-.7-.7-.7s-.7.31-.7.7v9.6h21.37v-9.6c0-.39-.32-.7-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.86,18.11c.09.08.2.13.32.13s.23-.05.32-.13l3.66-3.66c.09-.09.13-.2.13-.32s-.05-.23-.13-.32c-.08-.09-.2-.13-.32-.13,0,0,0,0,0,0-.12,0-.23.05-.32.13l-3.67,3.66c-.17.18-.17.46,0,.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealer);
export default __webpack_public_path__ + "static/media/dealer.9749f48773024e5ddb592a0ee72864e9.svg";
export { ForwardRef as ReactComponent };